import React from 'react';
import { CarouselData } from '../../../shared/dto/EntityRepository';
import { DisplaySize, PEInfoType } from '../../../shared/enum/EnumRepository';
import CarouselFrame from '../carousel/CarouselFrame';

export interface CarouselMobileProps {
  peId: string;
  data: CarouselData;
  displaySize: DisplaySize;
  infoType?: PEInfoType;
}

const CarouselMobile: React.FC<CarouselMobileProps> = (props) => (
  <CarouselFrame {...props} isMobile />
);

export default CarouselMobile;
